import React from "react";
import { useLang } from "../i18n/LanguageContext";
import { Phone, Mail, MapPin, ShieldCheck } from "lucide-react";

export default function Footer() {
  const { t } = useLang();
  const year = new Date().getFullYear();
  return (
    <footer data-testid="site-footer" className="bg-black border-t border-neutral-900">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-16 grid lg:grid-cols-12 gap-10">
        <div className="lg:col-span-5">
          <div className="flex items-center gap-3 mb-5">
            <span className="w-12 h-12 grid place-items-center bg-black border border-neutral-800 rounded-sm overflow-hidden">
              <img
                src="https://customer-assets.emergentagent.com/job_solid-construction-1/artifacts/inlh5dj3_C87BBE06-A887-4651-BCBA-A1A8D4641067.png"
                alt="Black Rock Construction Services LLC logo"
                className="w-full h-full object-cover"
              />
            </span>
            <span className="font-display uppercase text-white text-lg sm:text-xl tracking-tight">Black Rock Construction Services LLC</span>
          </div>
          <p className="text-neutral-400 text-sm leading-relaxed max-w-md">
            Residential construction specialists serving Birmingham and surrounding Alabama communities.
          </p>
          <div className="mt-6 inline-flex items-center gap-2 text-orange-500 font-mono-label text-xs uppercase tracking-[0.2em]">
            <ShieldCheck size={14} /> {t.footer.licensed}
          </div>
        </div>

        <div className="lg:col-span-3">
          <div className="font-mono-label uppercase text-[10px] tracking-[0.2em] text-neutral-500 mb-4">Services</div>
          <ul className="space-y-2">
            {t.services.items.map((s, i) => (
              <li key={i} className="text-neutral-300 text-sm">{s.name}</li>
            ))}
          </ul>
        </div>

        <div className="lg:col-span-4">
          <div className="font-mono-label uppercase text-[10px] tracking-[0.2em] text-neutral-500 mb-4">Contact</div>
          <ul className="space-y-3 text-sm">
            <li className="flex items-center gap-3 text-neutral-300">
              <Phone size={14} className="text-orange-500" /> <a href="tel:+12055383654" className="hover:text-orange-500">(205) 538-3654</a>
            </li>
            <li className="flex items-start gap-3 text-neutral-300">
              <Mail size={14} className="text-orange-500 mt-1" />
              <a href="mailto:blackrockconstructionservicess@gmail.com" className="hover:text-orange-500 break-all">blackrockconstructionservicess@gmail.com</a>
            </li>
            <li className="flex items-center gap-3 text-neutral-300">
              <MapPin size={14} className="text-orange-500" /> Birmingham, Alabama
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-neutral-900">
        <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <div className="font-display uppercase text-neutral-500 text-sm tracking-wide">
            &ldquo;{t.footer.tagline}&rdquo;
          </div>
          <div className="text-neutral-600 text-xs font-mono-label uppercase tracking-wide">
            © {year} Black Rock Construction Services LLC · {t.footer.rights}
          </div>
        </div>
      </div>
    </footer>
  );
}
